import { Component, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { CustomFormSignatureType } from 'src/app/model/enum/observations/custom-forms/custom-form-signature-type.enum';

@Component({
    selector: 'app-paetep-cf-builder-signature',
    templateUrl: './paetep-cf-builder-signature.component.html',
    styleUrls: ['./paetep-cf-builder-signature.component.scss'],
    viewProviders: [{
        provide: ControlContainer,
        useFactory: (container: ControlContainer) => container,
        deps: [[new SkipSelf(), ControlContainer]]
    }]
})
export class PaetepCfBuilderSignatureComponent {

    CustomFormSignatureType = CustomFormSignatureType;

    constructor() { }

}
